import { Box } from "@mui/material";
import { Typography } from "@pmag/ui-components";
import { useAttributeConfig } from "@src/hooks/useAttributeConfig";
import { splitTextAndLinks } from "@src/pages/subGroupDetail/SubgroupDetailPage.utils";
import { type FunctionComponent } from "react";

import { StyledLink, StyledSup } from "./PriceInfoContainer.styles";

export const PriceInfoContainer: FunctionComponent = ({ ...restProps }) => {
    const { priceInfoDisclaimer, quantityInfoDisclaimer } = useAttributeConfig();

    const resolveTextAndLinks = (textAndLinks: (string | { text: string; url: string })[]) => {
        return textAndLinks.map((element, index) => {
            if (typeof element === "object") {
                return (
                    <StyledLink href={element.url} key={`disclaimer-link-${index}`} target="_blank">
                        {element.text}
                    </StyledLink>
                );
            }

            return element;
        });
    };

    return (
        <Box {...restProps}>
            {priceInfoDisclaimer && (
                <Box mb={2}>
                    <Typography variant="helper-text-01">
                        <StyledSup marginRight={10}>*</StyledSup>

                        {resolveTextAndLinks(splitTextAndLinks(priceInfoDisclaimer))}
                    </Typography>
                </Box>
            )}

            {quantityInfoDisclaimer && (
                <Typography variant="helper-text-01">
                    <StyledSup marginRight={5}>**</StyledSup>

                    {resolveTextAndLinks(splitTextAndLinks(quantityInfoDisclaimer))}
                </Typography>
            )}
        </Box>
    );
};
